import request from "@/utils/request";

export function getNotify(params) {
  return request({
    url: "/notifications",
    method: "get",
    params
  });
}

export function markAllNotification() {
  return request({
    url: "/notifications/mark-all",
    method: "post"
  });
}

